export default __webpack_public_path__ + "static/2336-3201a7d9447d5605eb1cedc05c83d88f.gif";